import React from "react";

import Image from "../molecules/image";

import "../../scss/molecules/_image-container.scss";

class ImageContainer extends React.Component {
  render() {
    return (
      <div
        className={
          "image-container" +
          (this.props.negateTop ? " image-button-with-negate-top" : "")
        }
      >
        <Image
          fluid={this.props.fluid}
          src={this.props.src}
          alt={this.props.alt}
          overlay="gradient"
          aspectRatio="1x1"
        />
        <div className="image-container-body">{this.props.children}</div>
      </div>
    );
  }
}

export default ImageContainer;
